// @ts-nocheck
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { RCUtils } from './../../../RCUtils';
import Formatters from '../../../actions/Formatters';
import { PopupWindow } from './../../sharedcomponents/PopupWindow';
import { GridToolBar } from './../../sharedcomponents/GridToolBar';
import { ReeferCellRenderer } from '../../../actions/ReeferCellRenderer';
import $ from 'jquery';
import deletepng from '../../../images/delete.png';
var Config: any = require('../../../Config.json');


interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };


export interface PingGridState {
    SelectedReefers: any[];
    RowData: server.USP_RcdCurrentConditionUI[];
    Filters: server.ForwardCommandParameters;
    VCCheckBoxInfo: VCCheckBoxData;
    GridToolBarHtml: any;
}
var colDefs;
var self;
export class DevicePingControlForM2C extends React.Component<any, PingGridState> {
    constructor(props: any) {
        super(props);
        $('#globalLoader').show();
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedReefers: [], RowData: [], Filters: filterSet, VCCheckBoxInfo: emptyVCCheckBoxData, GridToolBarHtml: '' };
        colDefs = this.createColumnDefs();
        self = this;
    }

    componentDidMount() {
        this.renderGridToolBar();
       
       
        
        
        if (this.props.reeferData != null && this.props.reeferData.length > 0) {
            this.setState({ RowData: this.props.reeferData }, () => this.renderGridToolBar());
            this.renderPingGrid(this.props.reeferData);
        }
        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
    }

    submitPingCommand() {
        var command = "PollUnit";
        var refreshGrid = this.props.refreshGrid;
        this.submitTemperatureCommands(command, null);
    }

    submitTemperatureCommands(commandName, paramValue) {
        if (self.state.RowData.length > 0) {
            var selectedData = this.state.VCCheckBoxInfo.selectedVCData;
            if (this.state.VCCheckBoxInfo.enableVCCheckBox == true && (selectedData == null || selectedData.VesselId == 0)) { PopupWindow.showErrorMessage("Alert", "Please select vessel name"); }
            else {
                $('#globalLoader').show();
                self.state.Filters.CommandName = commandName;
                self.state.Filters.SelectedReefers = self.state.RowData;
                self.state.Filters.TempValue = paramValue;
                self.state.Filters.IsCmdSendViaVC = this.state.VCCheckBoxInfo.enableVCCheckBox;
                self.state.Filters.VesselInfo = this.state.VCCheckBoxInfo.selectedVCData;
                var forwardCommandParams = JSON.stringify(self.state.Filters);
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/PostForwardCommandsfromDeviceStatus', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<ValidationSeverityResult>)
                    .then(data => {
                        if (data != null && data != undefined) {
                            if (data.Result != null && data.Result != undefined && data.Result.length > 0) {
                                PopupWindow.showErrorMessage("Error", data.Result);
                                $(".mm-popup__box__body").css("white-space", "pre-line");
                                return;
                            }
                        }
                        $("#contextMenuModel .btn-close").click();
                        this.props.refreshRCDStatusGrid();
                    });
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            $('#globalLoader').show();
            this.setState({ RowData: reeferData }, () => this.renderGridToolBar());
            this.renderPingGrid(reeferData);
        }
        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
    }

    renderPingGrid(reeferData: any) {
        this.state.Filters.CommandName = "PollUnit";
        this.state.Filters.SelectedReefers = reeferData;
        this.setState({ RowData: reeferData }, () => this.renderGridToolBar());
        $('#globalLoader').hide();
    }

    setDefaultFilters() {
        var filters: server.ForwardCommandParameters = {
            SelectedReefers: [], CommandName: "PollUnit", TempValue: "", OtherValue: null, IsCmdSendViaVC: null, VesselInfo: null
        };
        return filters;
    }

    removeIndicator(params: any) {
        var element = document.createElement("span");
        element.className = "reefer-delete";

        var imageElement = document.createElement("img");
        imageElement.src = deletepng;
        imageElement.title = "Remove";

        imageElement.onclick = function DeleteCommands() {
            params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
            params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
        }

        element.appendChild(imageElement);

        return element;
    }

    refreshPingGrid() {
        var selectedRcds = "";
        if (this.state.RowData.length > 0) {
            $('#globalLoader').show();
            $.each(this.state.RowData, function (selectedIndex, selectedValue) {
                if (selectedValue.RCDID != null) {
                    selectedRcds = selectedRcds == "" ? selectedValue.RCDID : selectedRcds + "," + selectedValue.RCDID;
                }
            });
            var reeferSearchFilters: server.RcdStatusSearchFilters = { SelectedRcd: selectedRcds, SelectedCountry: null, SelectedInterval: null, SelectedGeofenceInside: null, SelectedGeofence: null, SelectedICCID: null, SelectedMSISDN: null, AllRcds: null, SelectedAssetType: null };

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/RcdStatus/RcdStatusSearchDataSP', { method: 'POST', body: JSON.stringify(reeferSearchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.USP_RcdCurrentConditionUI[]>)
                .then(data => {
                    this.setState({ RowData: data }, () => this.renderGridToolBar());
                    $('#globalLoader').hide();
                });
        }

        self.state.gridApiParams.paginationGoToFirstPage();
    };

    createColumnDefs() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Device ID", field: "RCDID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
            { headerName: "Asset ID", field: "AssetNumber", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "Last Event", field: "LastEvent", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
            { headerName: "Event Time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "R_EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
        ];
    }

    renderGridToolBar() {
        this.setState({ GridToolBarHtml: this.renderGridToolBarHtml() });
    }

    renderGridToolBarHtml() {
        return <GridToolBar refreshGrid={this.refreshPingGrid.bind(this)} gridData={this.state.RowData} colDefs={colDefs} parentchild={"P"} formName={"PollUnit"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)} />;
    }

    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    public render() {
        return <div>
            <div>
                {this.state.GridToolBarHtml}
            </div>
            <div className="ag-theme-fresh containerstyle_commands">
                <AgGridReact
                    columnDefs={colDefs}
                    rowData={this.state.RowData}
                    onGridReady={this.onGridReady}
                    pagination={true}
                    accentedSort={true}
                    paginationPageSize={25}>
                </AgGridReact>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitPingCommand.bind(this)}>Save</button>
               
            </div>
        </div>
    }
}
class ValidationSeverityResult {
    Serverity: string;
    Result: string;
}